import { z } from 'zod';
// Action-run API DTOs (snake_case wire contract). One record per action
// execution — the Activity feed + per-instance run history. See
// packages/db/src/schema/action-runs.ts and the Actions IA plan.
export const ACTION_RUN_STATUSES = ['running', 'succeeded', 'failed'];
export const actionRunSchema = z.object({
    id: z.string(),
    action_id: z.string().nullable(),
    // Denormalized action key + its human label (resolved server-side).
    action_key: z.string(),
    action_label: z.string(),
    // The saved action's name, when the run came from a saved instance.
    action_name: z.string().nullable(),
    project_id: z.string().nullable(),
    run_mode: z.string(),
    trigger_source: z.string(),
    status: z.enum(ACTION_RUN_STATUSES),
    started_at: z.string(),
    finished_at: z.string().nullable(),
    // The structured output (shape depends on action_key; narrowed in the UI).
    result: z.unknown().nullable(),
    error: z.string().nullable(),
    model_id: z.string().nullable(),
    billed_actions: z.number().nullable(),
    billed_credits: z.number().nullable(),
});
export const actionRunsListResponseSchema = z.object({
    runs: z.array(actionRunSchema),
    next_cursor: z.string().nullable(),
});
//# sourceMappingURL=action-runs.js.map